import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Pie } from 'react-chartjs-2';

class RelatorioGerencialVis extends React.Component {

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    formatarValor(s) {

        if (s === null) return "";
        else if (s === 0) return "0,00";

        return this.moneyMask(s);

    }

    render() {
        return(
            <div>
                <p Class={ "relatorio-ger-lbl" }>
                    <b>Centro:</b> { this.props.centroNome }
                    <b Style={ "margin-left: 35px;" }>Ano:</b> { this.props.ano }
                </p><br />
                <button type="button" id="relatorio-ger-voltar2-btn" onClick={ this.props.voltar2 }>
                    Voltar
                </button>
                <br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Receita Bruta:</b> R$ { this.formatarValor(this.props.relatorioGerencial.receita_bruta) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" }>
                    <b>Impostos e Deduções:</b> R$ { this.formatarValor(this.props.relatorioGerencial.impostos_deducoes) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Receita Líquida:</b> R$ { this.formatarValor(this.props.relatorioGerencial.receita_liquida) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" }>
                    <b>CMV:</b> R$ { this.formatarValor(this.props.relatorioGerencial.cmv) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Lucro Bruto:</b> R$ { this.formatarValor(this.props.relatorioGerencial.lucro_bruto) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" } Style={ "margin-left: 35px;" }>
                    <b>Margem Bruta:</b> { this.formatarValor(this.props.relatorioGerencial.margem_bruta.toFixed(2)) }%
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>SG&A:</b> R$ { this.formatarValor(this.props.relatorioGerencial.sg_a) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" } Style={ "margin-left: 35px;" }>
                    <b>Comercial:</b> R$ { this.formatarValor(this.props.relatorioGerencial.comercial) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" } Style={ "margin-left: 35px;" }>
                    <b>Administrativa:</b> R$ { this.formatarValor(this.props.relatorioGerencial.administrativa) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" } Style={ "margin-left: 35px;" }>
                    <b>Depreciação:</b> R$ { this.formatarValor(this.props.relatorioGerencial.depreciacao) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Lucro Operacional:</b> R$ { this.formatarValor(this.props.relatorioGerencial.lucro_operacional) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Juros:</b> R$ { this.formatarValor(this.props.relatorioGerencial.juros) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" }>
                    <b>Impostos:</b> R$ { this.formatarValor(this.props.relatorioGerencial.impostos) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Lucro Líquido:</b> R$ { this.formatarValor(this.props.relatorioGerencial.lucro_liquido) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Ebitda:</b> R$ { this.formatarValor(this.props.relatorioGerencial.ebitda) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" } Style={ "margin-left: 35px;" }>
                    <b>Ebitda (%):</b> { this.formatarValor(this.props.relatorioGerencial.ebitda_perc.toFixed(2)) }%
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Entradas Não Operacionais de Caixa:</b> R$ { this.formatarValor(this.props.relatorioGerencial.entrada_nop) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>CAPEX:</b> R$ { this.formatarValor(this.props.relatorioGerencial.capex) }
                </p><br />
                <p Class={ "relatorio-ger-lbl" }>
                    <b>Dívida:</b> R$ { this.formatarValor(this.props.relatorioGerencial.divida) }
                </p><br /><br />

                <p Class={ "relatorio-ger-lbl" }>
                    <b>Caixa do Ano:</b> R$ { this.formatarValor(this.props.relatorioGerencial.caixa_ano) }
                </p><br /><br /><br />

                <h1 Style={ "color: #666666;" }>
                    Receita
                </h1><br />
                <div Style={ "width: 500px;" }>
                    <Bar data={{
                            labels: [ "Receita Bruta", "Receita Líquida" ],
                            datasets: [
                                {
                                    label: "Receita",
                                    fill: false,
                                    backgroundColor: [
                                        "rgba(150, 200, 255, 1)",
                                        "rgba(150, 255, 200, 1)"
                                    ],
                                    borderColor: "rgba(0, 0, 0, 1)",
                                    borderWidth: 2,
                                    data: [
                                        this.props.relatorioGerencial.receita_bruta,
                                        this.props.relatorioGerencial.receita_liquida
                                    ]
                                }
                            ]
                        }} />
                </div><br /><br />

                <h1 Style={ "color: #666666;" }>
                    Lucro
                </h1><br />
                <div Style={ "width: 500px;" }>
                    <Bar data={{
                            labels: [ "Lucro Bruto", "Lucro Operacional", "Lucro Líquido" ],
                            datasets: [
                                {
                                    label: "Lucro",
                                    fill: false,
                                    backgroundColor: [
                                        "rgba(150, 200, 255, 1)",
                                        "rgba(150, 255, 200, 1)",
                                        "rgba(255, 255, 150, 1)"
                                    ],
                                    borderColor: "rgba(0, 0, 0, 1)",
                                    borderWidth: 2,
                                    data: [
                                        this.props.relatorioGerencial.lucro_bruto,
                                        this.props.relatorioGerencial.lucro_operacional,
                                        this.props.relatorioGerencial.lucro_liquido
                                    ]
                                }
                            ]
                        }} />
                </div><br /><br />

                <h1 Style={ "color: #666666;" }>
                    SG&A
                </h1><br />
                <div Style={ "width: 500px;" }>
                    <Pie data={{
                            labels: [ "Comercial", "Administrativa", "Depreciação" ],
                            datasets: [
                                {
                                    label: "SG&A",
                                    fill: false,
                                    backgroundColor: [
                                        "rgba(255, 150, 150, 1)",
                                        "rgba(255, 255, 150, 1)",
                                        "rgba(150, 220, 255, 1)"
                                    ],
                                    borderColor: [
                                        "rgba(90, 90, 90, 1)",
                                        "rgba(90, 90, 90, 1)",
                                        "rgba(90, 90, 90, 1)",
                                    ],
                                    borderWidth: 2,
                                    data: [
                                        this.props.relatorioGerencial.comercial,
                                        this.props.relatorioGerencial.administrativa,
                                        this.props.relatorioGerencial.depreciacao
                                    ]
                                }
                            ]
                        }} />
                </div><br /><br />

            </div>
        );
    }

}

export default RelatorioGerencialVis;

